import { Button } from 'primereact/button';
import React, { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import globalCourseStore from '../../../../../../../stores/global-course-store';
import { completeLectureOperation } from '../operations/complete-lecture-operation';
import globalLectureBuilderStore from '../../../../../../../stores/global-lecture-builder-store';
import { UserSummaryType } from '../../../../../../../api/types/user/user-summary.type';
import globalProgramStore from '../../../../../../../stores/program-store';
import { AttendanceType } from '../../../../../../../api/types/lecturers/attendance/attendance-type';
import { UserAttendanceRequest } from '../../../../../../../api/types/lecturers/attendance/user-attendance-request';
import { LectureAttendanceDetailsResponse } from '../../../../../../../api/types/lecturers/attendance/response/lecture-attendance-details-response';
import { AttendanceDataForm } from './attendance-data-form';
import { LectureTimePicker } from './lecture-time-picker';

interface LecturePageAttendanceDatamodel {
  lectureAttendance?: LectureAttendanceDetailsResponse[];
}
export const AttendanceLessonNotStartedDataForm: React.FC<LecturePageAttendanceDatamodel> =
  observer(({ lectureAttendance }) => {
    const [shouldAllowComplete, setShouldAllowComplete] = useState(false);

    const lecture = useMemo(
      () => globalLectureBuilderStore.selectedLecture,
      [globalLectureBuilderStore.selectedLecture],
    );

    // Initialize times with lecture's scheduled times
    const [startTime, setStartTime] = useState<Date>(
      lecture?.schedule?.startTime
        ? new Date(lecture.schedule.startTime)
        : new Date(),
    );
    const [endTime, setEndTime] = useState<Date>(
      lecture?.schedule?.endTime
        ? new Date(lecture.schedule.endTime)
        : new Date(),
    );

    // No need for useMemo since observer tracks MobX store changes
    const currentStudents: UserSummaryType[] =
      globalCourseStore.getCurrentCourse()?.details?.students ?? [];

    const attendanceData = useMemo(() => {
      return currentStudents?.map((item) => ({
        student: item,
      })) as {
        attendance?: AttendanceType;
        student: UserSummaryType;
      }[];
    }, [currentStudents]);

    const handleCompleteLecture = async (
      attendance: UserAttendanceRequest[],
    ) => {
      const programId = globalProgramStore.getCurrentId();
      await completeLectureOperation(
        programId,
        lecture,
        attendance,
        startTime,
        endTime,
      );
    };

    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {!shouldAllowComplete && (
          <div
            style={{
              marginTop: '8px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div>* הרצאה זו אינה בוצעה ולכן לא ניתן לסמן נוכחות</div>
            <Button
              severity={'secondary'}
              outlined={true}
              style={{ height: '30px', fontSize: '14px', marginRight: '8px' }}
              label={'לחץ לביצוע ההרצאה'}
              onClick={() => setShouldAllowComplete(true)}
            />
          </div>
        )}
        {shouldAllowComplete && (
          <>
            <LectureTimePicker
              startTime={startTime}
              endTime={endTime}
              onStartTimeChange={setStartTime}
              onEndTimeChange={setEndTime}
            />
            <AttendanceDataForm
              attendanceDataModel={attendanceData}
              handleCompleteLecture={handleCompleteLecture}
            />
          </>
        )}
      </div>
    );
  });
